import React from 'react';
import { Link } from 'react-router-dom';
import { BsInstagram, BsFacebook, BsTwitter } from 'react-icons/bs';

import { AppStoreButton } from 'components/ui/icons';
import SeoOnlyLink from 'components/utils/SeoOnlyLink';
import { isAndroidTwaApp } from 'components/utils/device';

import { useQueryDict } from 'hooks/app';

const Footer = () => {
  const { showSimpleFooter } = useQueryDict();
  const today = new Date();
  const year = today.getFullYear();
  const fbURL = 'https://www.facebook.com/BirthdayChannel';
  const instURL = 'https://www.instagram.com/birthdayalarm';
  const twtURL = 'https://twitter.com/birthdayalarm';
  const iOSURL = 'https://apps.apple.com/app/birthdayalarm/id594352154?pt=405762&mt=8&ct=bday-web-footer';

  const onAppStoreClick = () => {
    window.open(`https://birthdayalarm.com/track?label=ios_footer&url=${encodeURIComponent(`${iOSURL}&mt=8`)}`, '_blank');
  }

  const onFacebookClick = () => {
    window.open(fbURL, '_blank');
  }

  const onInstagramClick = () => {
    window.open(instURL, '_blank');
  }

  const onTwitterClick = () => {
    window.open(twtURL, '_blank');
  }

  if (showSimpleFooter) {
    return (
      <footer style={{ minHeight: 70 }}>
        <div style={{ textAlign: 'center', margin: '10px auto 0' }}>
          <span>© 2001-{year} birthdayalarm.com</span>
        </div>
      </footer>
    )
  }

  return (
    <footer>
      <div className="footer-links">
        <div className="footer-links-1">
          <Link to="/about">About Us</Link><span>|</span>
          <a href="https://support.birthdayalarm.com" target="_blank" rel="noopener noreferrer">FAQ</a><span>|</span>
          <Link to="/contact">Contact Us</Link>
        </div>
        <div className="footer-links-2">
          <Link to="/company">© 2001-{year}</Link><span>•</span>
          <Link to="/company">Legal</Link><span>•</span>
          <Link to="/terms">Terms</Link><span>•</span>
          <Link to="/privacy">Privacy Policy</Link><span>•</span>
          <a href="https://zuno.com" target="_blank" rel="noreferrer">Powered by Zuno</a>
        </div>
      </div>
      <div className="footer-app-links">
        <SeoOnlyLink to={fbURL} onClick={onFacebookClick} aria-label="BirthdayAlarm Facebook Page">
          <BsFacebook className="social-icon"/>
        </SeoOnlyLink>
        <SeoOnlyLink to={instURL} onClick={onInstagramClick} aria-label="BirthdayAlarm Instagram Page">
          <BsInstagram className="social-icon"/>
        </SeoOnlyLink>
        <SeoOnlyLink to={twtURL} onClick={onTwitterClick} aria-label="BirthdayAlarm Twitter Page">
          <BsTwitter className="social-icon"/>
        </SeoOnlyLink>
        {!isAndroidTwaApp &&
          <SeoOnlyLink to={iOSURL} onClick={onAppStoreClick} aria-label="BirthdayAlarm iOS App">
            <AppStoreButton className="app-store-button"/>
          </SeoOnlyLink>
        }
      </div>
    </footer>
  );
}

export default Footer;
